"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSessionValidation = void 0;
const ChargingSessionAttemptValidation_1 = require("./ChargingSessionAttemptValidation");
class ChargingSessionValidation {
    static isValid(entity) {
        // Validate entity.id for existence and correct type.
        if (entity.id == undefined)
            return false;
        if (typeof entity.id !== "string")
            return false;
        // If entity.evcc_id exists, validate that it has the correct type.
        if (entity.evcc_id != undefined) {
            if (typeof entity.evcc_id !== "string")
                return false;
        }
        // If entity.payment_token exists, validate that it has the correct type.
        if (entity.payment_token != undefined) {
            if (typeof entity.payment_token !== "string")
                return false;
        }
        // If entity.membership_token exists, validate that it has the correct type.
        if (entity.membership_token != undefined) {
            if (typeof entity.membership_token !== "string")
                return false;
        }
        // Validate entity.first_attempt_of_charging for existence and correct type.
        if (entity.first_attempt_of_charging == undefined)
            return false;
        if (!(entity.first_attempt_of_charging instanceof Date))
            return false;
        // Validate entity.attempts for existence and correct type.
        if (entity.attempts == undefined)
            return false;
        if (!Array.isArray(entity.attempts))
            return false;
        if (!entity.attempts.every((elem) => {
            if (!ChargingSessionAttemptValidation_1.ChargingSessionAttemptValidation.isValid(elem))
                return false;
            return true;
        }))
            return false;
        return true;
    }
}
exports.ChargingSessionValidation = ChargingSessionValidation;
